import Alert from 'client/components/aria/Alert/Alert';
import { FormattedMessage, useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import ButtonGroup from 'client/components/aria/ButtonGroup/ButtonGroup';
import Button from 'client/components/aria/Button/Button';
import { useNavigate } from 'react-router';
import { WORKPACKS_PAGE } from 'client/utils/routes/routeConstants';
import styles from './WorkpackAlertError.module.scss';

const WorkpackAlertError = (props) => {
    const intl = useIntl();
    const navigate = useNavigate();

    const handleConfirmation = () => {
        navigate(WORKPACKS_PAGE);
    };

    return (
        <>
            <div className="govuk-grid-row" data-testid="workpack-alert-error-container">
                <Alert
                    data-testid="workpack-alert-error"
                    title={ intl.formatMessage({ id: 'workpackAlerts.error.title' })}
                    variant="info"
                    { ...props }
                >
                    <FormattedMessage id="workpackAlerts.error"/>
                </Alert>
            </div>
            <div className="govuk-grid-row" data-testid="workpack-alert-error-actions">
                <div className="govuk-grid-column-full">
                    <ButtonGroup className={styles.buttons}>
                        <Button
                            data-testid="workpackAlerts.button.ok"
                            variant="success"
                            onPress={handleConfirmation}
                        >
                            { intl.formatMessage({ id: 'workpackAlerts.button' })}
                        </Button>
                    </ButtonGroup>
                </div>
            </div>
        </>
    );
};

WorkpackAlertError.propTypes = {
    ...defaultAriaProps
};

export default WorkpackAlertError;
